<template>
  <div class="analysisCandidates">
    <analysis-sidebar></analysis-sidebar>
    <div class="text-center" id="welcome">
    </div>
    <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/Analysis/analysis_candidates.vue" target="_blank" style="color:black">
      <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
    </a>
    <h4>Science Analysis</h4>
    <candidates></candidates>
  </div>
</template>

<script>
import pipelineComponents from './pipeline_components'
import analysisSidebar from './analysisSidebar'
export default {
  data () {
    return {
      userRole: 'MEMBER',
      userTeam: '',
      userName: '',
      eventFields: [
        {key: 'event_id', label: 'Event Id', 'class': 'text-left'},
        {key: 'assigned_users', label: 'Assigned To', 'class': 'text-left'},
        {key: 'snr', label: 'SNR', 'class': 'text-left'},
        {key: 'dm', label: 'DM', 'class': 'text-left'},
        {key: 'ra', label: 'RA', 'class': 'text-left'},
        {key: 'dec', label: 'DEC', 'class': 'text-left'},
        {key: 'actions', label: 'Actions', 'class': 'text-left'}
      ],
      unsavedEvents: [],
      myunsavedEvents: [],
      savedEvents: [],
      mysavedEvents: [],
      flaggedEvents: [],
      myflaggedEvents: [],
      badEvents: [],
      mybadEvents: [],
      baseUrl: 'https://frb.chimenet.ca/frb-master/'
      // baseUrl: 'http://localhost:8001'
    }
  },
  methods: {
  },
  components: {
    'candidates': pipelineComponents,
    'analysis-sidebar': analysisSidebar
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Analysis/analysis_candidates.vue